<template>
  <v-container class="menu-main-sub-categories-view" data-testid="MenuSubCategories-SubCategories">
    <v-btn
      v-show="fab"
      v-scroll="onScroll"
      color="primary" fab fixed bottom right
      @click="toTop()"
      class="up-catalogo-productos"

    >
      <v-icon>fa-light fa-chevron-up</v-icon>
    </v-btn>
    <div v-if="windowSize.is_movile">
      <div :class="activeClassMovileMenuCategories ? 'mb-5' : 'menu-sticky mb-5'">
        <menu-categories :tipe="instance.tipe_menu" :categories="categories" @seeProducts="seeProducts" />
      </div>
      <v-row>
        <v-col cols="12">
          <div v-for="cat in CategoriesFilter" :key="cat.id" v-show="showCard(cat)" class="mt-4">
            <sub-category-custom :cat="cat" v-if="instance.cluvi_add_ons?.includes('custom_banner')"  ></sub-category-custom>
            <sub-category-basic :cat="cat" v-else ></sub-category-basic>
            <menu-promos-y-combos v-if="cat.id === 1" />
            <list-products :productsId="cat.product_ids" :numProductsBefore="cat.numProductsBefore" :categoryPosition="cat.position" :categoryId="cat.id.toString()" :productsCategorie="cat.products" :is_ontable_service="is_ontable_service" />
          </div>
        </v-col>
        <banners-main-categories  :trigger="'banner-sub-categories'"/>
      </v-row>
    </div>
    <v-row v-if="!windowSize.is_movile">
      <v-col md="3" cols="3">
        <menu-categories-desktop :categories="categories" :windowSize="windowSize" class="menu-fix-menu-left" />
      </v-col>
      <v-col md="9" cols="9">
        <div v-for="cat in CategoriesFilter" :key="cat.id" class="ml-5 mt-4">
          <sub-category-custom :cat="cat" v-if="instance.cluvi_add_ons?.includes('custom_banner')"  ></sub-category-custom>
          <sub-category-basic :cat="cat" v-else ></sub-category-basic>
          <small v-if="cat.description != null" v-html="cat.description" />
          <menu-promos-y-combos v-if="cat.id === 1" class="mt-4 ml-5" />
          <list-products :productsId="cat.product_ids" :numProductsBefore="cat.numProductsBefore" :categoryPosition="cat.position" :categoryId="cat.id.toString()" :productsCategorie="cat.products" :is_ontable_service="is_ontable_service" />
        </div>

          <banners-main-categories class="ml-2 mt-4"  :trigger="'banner-sub-categories'"/>
        
      </v-col>
      
    </v-row>
    <delivery-current-cart-bottom v-if="(service === 'delivery' || service === 'take_away') && (purchaseId !== null || taPurchaseId !== null)" />
    <on-table-current-cart-bottom v-if="service ==='on_table' && (otPurchaseId !== null || (supplier.on_table_class === 'basic' && supplier.has_cluvi_pay))" @emptyList="showDialog"/>
    <ot-dialog v-if="otdialog" :data="dialogData" @dismiss="otdialog = false" @gotomenu="otdialog = false" />
    <div style="height: 70px;"></div>
    <rate-tab />
  </v-container>
</template>

<script>
import { mapActions,mapMutations,mapState,mapGetters } from "vuex";
import { misMixins } from "@/mixins/mixins.js";
import { menu } from "../services/menu";
import { track } from "../services/track-custom";
import { dbFunctions } from '@/services/indexedDB';

export default {
  name: "MenuSubCategories",
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (from.name === 'OnTableHome' || from.name === 'Home') vm.$store.state.shared.flatHomeMainCategories = from.name;
    });
  },
  beforeRouteLeave (to, from, next) {
    let tipeMenu = 'images';
    let arrayNameRoutes = ['MyOrder', 'DeliveryCartInProgress'];
    if (this.instance.tipe_menu !== tipeMenu && this.product_id) {
      if (arrayNameRoutes.includes(to.name)) {
        this.SetProductId(null);
        next();
      } else {
        next(false);
      };
    } else if (this.instance.tipe_menu === tipeMenu && this.$route.query.category_id) {
      next(false);
      this.navigationMenuImages();
    } else {
      next();
    };
  },
  components: {
    MenuCategories: () => import(/* webpackChunkName: "MenuCategories" */ '../components/menu/MenuCategories'),
    MenuCategoriesDesktop: () => import(/* webpackChunkName: "MenuCategoriesDesktop" */ '../components/menu/MenuCategoriesDesktop'),
    MenuPromosYCombos: () => import(/* webpackChunkName: "menuPromosYCombos" */'@/components/menu/MenuPromosYCombos'),
    OnTableCurrentCartBottom: () => import(/* webpackChunkName: "onTableCurrentCartBottom" */ '@/components/on_table/CurrentCartBottom'),
    DeliveryCurrentCartBottom: () => import(/* webpackChunkName: "deliveryCurrentCartBottom" */ '@/components/delivery/CurrentCartBottom'),
    OtDialog: () => import(/* webpackChunkName: "otDialog" */ '@/components/on_table/OtDialog.vue'),
    ListProducts: () => import(/* webpackChunkName: "otDialog" */ '@/components/menu/ListProducts.vue'),
    SubCategoryBasic  : () => import(/* webpackChunkName: "otDialog" */ '@/components/menu/SubCategoryBasic.vue'),
    SubCategoryCustom  : () => import(/* webpackChunkName: "otDialog" */ '@/components/menu/SubCategoryCustom.vue'),
    BannersMainCategories: () => import(/* webpackChunkName: "BannersMainCategories" */ '@/components/banners/MainCategories')
  },
  data: () => ({
    filterMessage: false,
    fab: false,
    ProductsMenu: false,
    products: [],
    categories: [],
    acordeon: false,
    otdialog: false,
    dialogData: {
      title: '',
      message: '',
      btns: []
    },
    labels: {},
    promotions: {},
    main_categories: null,
    show_details: false,
    idCategorieUrl: 0
  }),
  computed: {
    ...mapState('customer', ["instance","supplier"]),
    ...mapState('shared', ['windowSize','mainCategoryId','openMenuTop','product_id','category_grid']),
    ...mapState('order', ["service","subservice", "purchaseId", "taPurchaseId", "otPurchaseId", "otPurchaseId"]),
    ...mapState('bookings', ['bookBanner']),
    ...mapState('template', ['isFirefox']),
    ...mapGetters('order', ["is_ontable_service"]),
    CategoriesFilter() {
      return this.$store.state.shared.productsFilter === 'all' ? this.categories : this.categories.filter(element => element.id === this.$store.state.shared.productsFilter);
    },
    activeClassMovileMenuCategories () {
      return this.fab === false && this.instance.tipe_menu === 'images' || this.fab === true && this.instance.tipe_menu === 'accordion' && this.acordeon === true;
    }
  },
  watch: {
    supplier (val) {
      if (!val.id) this.GoSelectSupplier();
    },
    $route (newRute,oldRute) {
      this.watchChangeRoute(newRute,oldRute);
    }
  },
  created () {
    if(this.instance.cluvi_add_ons.includes('newhome')){
      this.$router.push({
          name: "OnTableNewHome",
          params: {supplier_id: this.supplier.slug}
        });
    }
    this.SetLoading(true);
    this.routeHome();
    this.SetLoading(true);
    this.reloadGetSupplier();
    this.initSubCatMenu();
  },
  mixins: [ misMixins ],
  methods: {
    ...mapActions('customer', ["GetSupplier"]),
    ...mapMutations('template', ["SetLoading","TemplateActiveHeader","SetAppClass"]),
    ...mapMutations('shared', ["SetProductId", "setMainCategory","SetCategoryGrid"]),
    ...mapMutations("template", ["SetReload"]),
    navigationMenuImages() {
      this.show_details = false;
      this.ProductsMenu = false;
      this.$router.replace({ query: {} });
      if (this.bookBanner === true) this.TemplateActiveHeader({ header_type: "tobook" });
      else this.TemplateActiveHeader({ header_type: this.instance.back_option_menu });
    },
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    seeProducts(item) {
      if (item === false) this.acordeon = true;
      else this.acordeon = false;
      if (this.category_grid === 1 && this.instance.tipe_menu === "accordion") {
        if (this.windowSize.is_movile) item = true;
        else item = false;
        this.SetCategoryGrid(0);
      };
      this.ProductsMenu = item;
    },
    getMainCategorie() {
      const id = this.idCategorieUrl;
      let mainCategoriePromise;
      if (id) {
        mainCategoriePromise = dbFunctions.getMainCategorieIDB(id)
          .then(mainCategorie => {
            this.categories = mainCategorie.subcategories;
            this.TemplateActiveHeader({ header_type: "maincategories", label: mainCategorie.label });
          })
          .catch(error => {
            console.error(error);
          });
      } else {
        mainCategoriePromise = dbFunctions.getCategoriesIDB()
          .then(categories => {
            this.categories = categories;
          })
          .catch(error => {
            console.error(error);
          });
      };
      return mainCategoriePromise
        .then(() => {
          this.categories = this.categories.filter(element => element.product_ids?.length);
          this.addCategorieAll();
          this.getPromos();
        })
        .catch(error => {
          console.error(error);
        });
    },
    getPromos() {
      menu.getPromos(this.supplier.id,this.service)
        .then(response => {
          if (response) {
            this.promotions = response.data.promociones;
            this.addCategoriePromo();
            this.organizeMenu();
            this.SetLoading(false);
          };
        })
        .catch(error => {
          console.error(error,'entre aqui');
        });
    },
    addCategoriePromo () {
      if (this.promotions.products?.length) {
        this.categories.splice(1, 0, {
          id: this.promotions.id,
          image: null,
          image_banner: null,
          label: this.promotions.category,
          order: 0,
          main_category_id: 0,
          quantity_previous_products: 0,
          type: "SupplierCategory",
          subcategories: [],
          product_ids: [],
          products: this.promotions.products
        });
      };
    },
    addCategorieAll () {
      if (this.categories?.length && this.instance.slug !== "central-cevicheria") {
        this.categories.map(cat => {
          if (cat.subcategories?.length && cat.id !== 0) {
            const dataAll = {
              id: 'all',
              image: null,
              image_banner: null,
              label: this.$t("all"),
              order: 0,
              main_category_id: cat.id,
              quantity_previous_products: 0,
              type: "SupplierCategory",
              subcategories: [],
              product_ids: [],
              products: []
            };
            cat.subcategories.unshift(dataAll);
          };
        });
        if (this.categories[0].id !== 0) {
          const dataAll = {
            id: 'all',
            image: null,
            image_banner: null,
            label: this.$t("all"),
            order: 0,
            main_category_id: 1,
            quantity_previous_products: 0,
            type: "SupplierCategory",
            subcategories: [],
            product_ids: []
          };
          this.categories.unshift(dataAll);
        };
      };
    },
    async getCategoriesProductsPromos() {
      try {
        const response = await Promise.all([ menu.getProducts(this.supplier.id,this.service),menu.getPromos(this.supplier.id,this.service),menu.getCategoriesByMain(this.mainCategoryId) ]);
        const products = response[0];
        const promotions = response[1];
        const categories = response[2];
        this.products = products.data.productos;
        this.promotions = promotions.data.promociones;
        if (categories) {
          this.categories = categories.data.categorias;
          this.organizeMenu();
        };
        this.SetLoading(false);
      } catch (error) {
        console.error(error)
        this.SetLoading(false);
      }
    },
    organizeMenu() {
      if (this.categories?.length === 1) this.SetCategoryGrid(1);
      if (this.category_grid === 1 && this.instance.tipe_menu === "accordion") this.seeProducts();
      setTimeout(() => this.filterMessage = false, 2500);
      if (!this.is_ontable_service || this.isFirefox) {
        if (this.categories?.length > 1 && this.instance.slug !== "central-cevicheria") this.categories.unshift({ category: this.$t("all"),id: "all" });
        if (this.promotions.products && this.promotions.products?.length > 0) {
          this.categories.splice(1, 0, {
            category: this.promotions.category,
            id: this.promotions.id,
            products: this.promotions.products,
          });
        };
        let numProductsBefore = 0;
        for (let i = 0; i < this.categories?.length; i++) {
          const categoryId = this.categories[i].id;
          this.categories[i].numProductsBefore = numProductsBefore;
          this.categories[i].position = i;
          if(categoryId !== 1){
            this.categories[i].products = this.products.filter(element => element.supplier_category_id === categoryId);
          }
          if (this.categories[i].products === null) this.categories[i].products = [];
          numProductsBefore = numProductsBefore + this.categories[i].products?.length;
        };
      };
    },
    async getMainCategory(main_category_id) {
      try {
        const response = await menu.getMainCategory(main_category_id);
        if (response) this.TemplateActiveHeader({ header_type: "maincategories",label: response.data.label });
      } catch (error) {
        console.error(error);
      };
    },
    GoSelectSupplier() {
      this.$router.push({ name: "Main" });
    },
    showDialog(data) {
      this.dialogData = { ...this.dialogData, ...data };
      this.otdialog = true;
    },
    showCard(cat) {
      let service = this.service !== 'on_table' || this.isFirefox ? cat.products?.length : cat.product_ids?.length;
      return (service || cat.id === 1) &&
      (
        (this.instance.tipe_menu === 'accordion' && this.windowSize.x < 980) ||
        ((this.instance.tipe_menu === 'images' && this.windowSize.x < 980)? !this.ProductsMenu: this.ProductsMenu) ||
        ((this.instance.tipe_menu === 'images' && this.windowSize.x < 980 && !this.show_details)? this.ProductsMenu: !this.ProductsMenu)
      )
    },
    initSubCatMenu () {
      if (this.$route.query.category_id) this.setMainCategory(0);
      if (this.$route.query.maincategory_id || this.mainCategoryId > 0) {
        let main_category_id = this.$route.query.maincategory_id ? Number(this.$route.query.maincategory_id) : this.mainCategoryId;
        this.setMainCategory(main_category_id);
        if (!this.is_ontable_service || this.isFirefox) this.getMainCategory(main_category_id);
      };
      if (this.bookBanner) this.TemplateActiveHeader({ header_type: "tobook" });
      else this.TemplateActiveHeader({ header_type: this.instance.back_option_menu });
      if (this.$route.query.category_id && this.instance.tipe_menu === 'images') this.seeProducts(true);
    },
    routeHome() {
      const isInvalidSupplier = this.supplier.id === 0;
      const isInvalidService = !this.$store.state.order.service;

      if (isInvalidSupplier || isInvalidService) {
        this.$router.push({
          name: "Home",
          params: { supplier_id: this.$route.params.supplier_id },
        });
      }
    },
    getMainCategorieForUrl () {
      if (this.$route.query.maincategory_id) {
        this.idCategorieUrl = Number(this.$route.query.maincategory_id) || Number(this.mainCategoryId);
      } else {
        const categoryId = Number(this.$route.query.category_id);
        if (categoryId) {
          dbFunctions.getCategoriesIDB()
            .then(mainCategories => {
              const foundCategory = mainCategories.find(category => {
                const subCategory = category.subcategories.find(sub => sub.id === categoryId);
                return subCategory;
              });
              if (foundCategory) {
                const subCategory = foundCategory.subcategories.find(sub => sub.id === categoryId);
                this.idCategorieUrl = subCategory.main_category_id;
                this.getMainCategorie();
              };
            })
            .catch(error => {
              console.error(error);
            });
        }
      };
      this.getMainCategorie();
    },
    setStateSharedProductsFilter () {
      let categorie_id = this.$route.query.category_id;
      if (this.categories && this.categories?.length === 1) this.$store.state.shared.productsFilter = this.categories[0].id;
      else if (categorie_id) this.$store.state.shared.productsFilter = Number(categorie_id);
      else this.$store.state.shared.productsFilter = 'all';
    },
    watchChangeRoute(newRute,oldRute) {
      const newMainCategoryId = Number(newRute.query.maincategory_id);
      const oldMainCategoryId = Number(oldRute.query.maincategory_id);
      if (newMainCategoryId && oldMainCategoryId && newMainCategoryId !== oldMainCategoryId) this.SetReloadWithDelay();
      else this.updateProductsFilter(newRute);
    },
    SetReloadWithDelay () {
      this.SetReload(false);
      setTimeout(() => this.SetReload(true), 500);
    },
    updateProductsFilter (newRute) {
      const categoryId = newRute.query.category_id;
      this.$store.state.shared.productsFilter = categoryId ? Number(categoryId) : 'all';
    }
  },
  mounted () {
    this.setStateSharedProductsFilter();
    track.trackView(this, `Menu`, `/${this.supplier.slug}/menu`);
    track.trackEventCluvi({}, "view menu");
    if (!this.is_ontable_service || this.isFirefox) this.getCategoriesProductsPromos();
    else this.getMainCategorieForUrl();
    this.SetLoading(false);
  },
  metaInfo() {
    return {
      title: this.supplier.label
    };
  }
};
</script>

<style scoped lang="scss">
  .cat_has_image {
    display: none;
  }
</style>